import { toKebabCase } from '@nova/core';

/**
 * The `<id>-custom-field-input` test id that String, Number and Email put on their wrapper, where
 * `<id>` is the explicit `testId` or else the kebab-cased label.
 *
 * With neither, there is nothing to identify the field by, so no id is returned and the attribute
 * is left off, rather than rendering `undefined-custom-field-input` (a label-less field built by
 * the host, such as the asset code in YardViewAssetContainerFormDataV2).
 */
export function customFieldInputTestId(
  testId: string | undefined,
  label: string | undefined
): string | undefined {
  const baseId = testId || toKebabCase(label ?? '');
  return baseId ? `${baseId}-custom-field-input` : undefined;
}
